import NextImage from 'next/image';

export default NextImage;
